import React from 'react';
import { useSelector } from 'react-redux';
import { Box, HStack, Stack, Text, useColorMode } from '@chakra-ui/react';

import { i_h3 } from '../../../../style';
import PoolLiquidityList from './components/PoolList';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import PageLayout, { AdaptationMode } from '../../../../components/layout/PageLayout';
import Controls from '../../components/Controls';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import { RootState, RootDispatch } from '../../../../state/store';
import { useRematchDispatch } from '../../../../hooks/useRematchDispatch';
import IZiLinkButton from '../../../../components/Buttons/iZiLinkButton/iZiLinkButton';
import ValidChainWrapper from '../../../components/ChainNotValidBlock';
import TypeSelect from '../../components/TypeSelect';
import { getColorThemeSelector } from '../../../../utils/funcs';
import NetworkSelect from '../../../../components/Select/NetworkSelect/NetworkSelect';
import { useTranslation } from 'react-i18next';
type FarmProps = {
    type?: AdaptationMode;
};
const Farm: React.FC<FarmProps> = (props) => {
    const { type } = props;
    useDocumentTitle('Farm | Arctic');
    const { farmFixRangeiZi: farm } = useSelector((state: RootState) => state);
    const { dispatch } = useRematchDispatch((dispatch: RootDispatch) => ({
        dispatch,
    }));
    const { t } = useTranslation();
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);

    return type === 'mobile' ? (
        <PageLayout
            body={
                <ValidChainWrapper
                    content={
                        <Stack w="100%">
                            <Controls farm={farm} dispatch={dispatch.farmFixRangeiZi} />
                            <TypeSelect dex="iZi" type="mobile" />
                            <Box h="15px" />
                            <PoolLiquidityList />;
                        </Stack>
                    }
                    app="farm"
                />
            }
            type="mobile"
        />
    ) : (
        <PageLayout
            header={
                <PageHeader
                    headerTitle={t('Liquidity Mining')}
                    subtitle={t('Stake your iZiSwap NFTs to earn rewards')}
                    element={
                        <HStack spacing="10px">
                            <IZiLinkButton />
                            <NetworkSelect />
                        </HStack>
                    }
                />
            }
            body={
                <ValidChainWrapper
                    content={
                        <Stack w="100%">
                            <Controls farm={farm} dispatch={dispatch.farmFixRangeiZi} />
                            <TypeSelect dex="iZi" />
                            <Box h="10px" />
                            <PoolLiquidityList />;
                        </Stack>
                    }
                    app="farm"
                />
            }
            internalWidth={{ base: '100%', sm: '700px', xl: '840px', xxl: '1100px', xlp1: '1150px' }}
        />
    );
};

export default Farm;
